import flow from "lodash-es/flow";

import {
    findTextsContainsPattern,
    getElementsByTagName,
    getSearchFromHref,
    retrieveParamsFromSearch
} from "../utils";

// get$ufScriptSrc :: I$ufNS -> String
function retrieve$ufScriptSrc() {
    if (window.$uf && window.$uf.s) {
        return window.$uf.s.src;
    }
    // const elements = <NodeListOf<HTMLScriptElement>>getElementsByTagName("script");
    const elements = getElementsByTagName("script");

    const a = Array.prototype.map.call(elements, script => script.src);

    const pattern = /.*unifiedfactory.(com|net)\//;

    const srcs = findTextsContainsPattern(a, pattern);

    return srcs[0] || "";
}

export default flow(
    retrieve$ufScriptSrc,
    getSearchFromHref,
    retrieveParamsFromSearch
);
